import { canUseDOM } from '../../utils';
export const runValidations = function (validationFunctions) {
  for (var _len = arguments.length, validateParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    validateParams[_key - 1] = arguments[_key];
  }
  for (let validate of validationFunctions) {
    if (!validate(...validateParams)) return false;
  }
  return true;
};
export const validateRequired = (value, fieldObj) => {
  value = value.trim();
  if (value.length) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  }
};
export const validateRequiredSelect = (value, fieldObj) => {
  if (value === '-1' || value === -1) {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export const validateMaxLength = (value, fieldObj) => {
  if (value.length <= fieldObj.maxLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMaxLength);
    return false;
  }
};
export const validateMinLength = (value, fieldObj) => {
  if (value.length >= fieldObj.minLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMinLength);
    return false;
  }
};
export const validateRegex = regEx => {
  return (value, fieldObj) => {
    if (regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};
export const validateRegexInverse = regEx => {
  return (value, fieldObj) => {
    if (!regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};

// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// export const validateAlphanumeric = validateRegex(/^[\u0621-\u064A\u0660-\u06690-9a-zA-Z]+$/);

let alphaNumericRegex = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g;
export const validateEmail = validateRegex(/^.+\@.+\..+$/);
export const validateAlphanumeric = validateRegexInverse(alphaNumericRegex);
export const validatePassword = validateRegex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}/);
export const handleErrors = response => {
  if (!response.ok) {
    const status = response.status;
    if (status === 401) {
      throw Error(`Unauthorized access`);
    } else {
      throw Error(response.statusText);
    }
  }
  return response;
};
export const validateRequiredCheckbox = (value, fieldObj) => {
  const errorsList = [];
  for (const checkbox of fieldObj.checkboxes) {
    if (checkbox.isRequired && checkbox.isRequired === true && checkbox.value === false) {
      errorsList.push(checkbox.errorRequired);
    }
  }
  if (errorsList.length) {
    fieldObj.setError(errorsList.join('[|]'));
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export const loaderToggle = (toggle, btnStateDisable) => {
  if (canUseDOM) {
    if (toggle) {
      btnStateDisable(true);
      document.body.classList.add('loader--show');
    } else {
      btnStateDisable(false);
      document.body.classList.remove('loader--show');
    }
  }
};